.<template>
  <div class="loader">
    <!-- <img class="logo" alt="logo" src="../assets/logo.svg" />
    <br /> -->
    <div class="lds-ring">
      <!-- <div></div>
      <div></div>
      <div></div>
      <div></div> -->
      <svg
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318 318">
          <g id="Ellipse_1" data-name="Ellipse 1" style="isolation: isolate">
              <path d="M159,0A159,159,0,1,0,318,159,159.00006,159.00006,0,0,0,159,0ZM221.989,77.85a39,39,0,1,1-14.275,53.275A39,39,0,0,1,221.989,77.85ZM159,25a39,39,0,1,1-39,39A39,39,0,0,1,159,25ZM133.91333,186.70142A7.75,7.75,0,1,1,136.75,197.28815,7.75,7.75,0,0,1,133.91333,186.70142ZM136.75,120.21185a7.75,7.75,0,1,1-2.83667,10.58673A7.75007,7.75007,0,0,1,136.75,120.21185ZM137,158.5a22,22,0,1,1,22,22A22,22,0,0,1,137,158.5Zm36.5,25.36475a7.75,7.75,0,1,1-2.83673,10.58667A7.75,7.75,0,0,1,173.5,183.86475Zm10.58667-53.06617A7.75,7.75,0,1,1,181.25,120.21185,7.75,7.75,0,0,1,184.08667,130.79858ZM42.73608,92.125a39,39,0,1,1,14.275,53.275A39,39,0,0,1,42.73608,92.125Zm53.275,148.525a39,39,0,1,1,14.275-53.275A39,39,0,0,1,96.01105,240.65Zm18.489-81.9a7.75,7.75,0,1,1,7.75,7.75A7.75,7.75,0,0,1,114.5,158.75ZM159,293.5a39,39,0,1,1,39-39A39,39,0,0,1,159,293.5Zm36.75-127a7.75,7.75,0,1,1,7.75-7.75A7.75,7.75,0,0,1,195.75,166.5Zm79.51392,59.875a39,39,0,1,1-14.275-53.275A39,39,0,0,1,275.26392,226.375Z" fill="#ffffff"/>
          </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.logo {
  width: 120px;
  padding-bottom: 20px;
}
h3 {
  padding-top: 50px;
  text-align: center;
  color: white;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 10vw;
  height: 10vw;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 46px;
  height: 46px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring svg {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 8vw;
  height: 8vw;
  animation: lds-ring 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 600px) {
  .lds-ring svg {
    width: 10vw;
    height: 10vw;
  }
}
</style>